import BaseError from "@/errors/base-error";

export default class OwnerNotFoundError extends BaseError {}
